import { isOptionOpen, isProducerDown } from '@/utils/option-status';

import { SbkPromoCriterion } from '../../types';
import { BetIds, isComboSelectionEnabled } from '../betslip-utils';
import { CriteriaState, CriterionValidator } from './criterion-validators';

/**
 * Suspended picks don't count, matching bet submission, which excludes them
 * from the placed bet.
 */
export const getPickCount = (state: CriteriaState, betId: string) => {
    if (betId === BetIds.COMBO) {
        return Object.values(state.selections).filter(selection => isComboSelectionEnabled(selection, state)).length;
    }
    const selection = state.selections[betId];
    const isOpen =
        selection &&
        isOptionOpen(
            state.options[selection.optionId]?.status,
            isProducerDown(state.producerStatuses, state.markets[selection.marketId]?.supplier),
            state.markets[selection.marketId]?.published
        );
    return isOpen ? 1 : 0;
};

const getMinPicksValue = (criterion: SbkPromoCriterion) => Number(criterion.parameters?.VALUE);

export const minNumberOfPicksCriterion: CriterionValidator = {
    validate: (criterion, state, betId) => {
        const minPicks = getMinPicksValue(criterion);
        return isNaN(minPicks) || getPickCount(state, betId) >= minPicks;
    },
    isVisibleForBet: (criterion, betId) => {
        const minPicks = getMinPicksValue(criterion);
        return betId === BetIds.COMBO || isNaN(minPicks) || minPicks <= 1;
    },
    translationKey: 'min_picks_required',
    getTranslationParams: criterion => ({ count: getMinPicksValue(criterion) }),
};
